import { render, staticRenderFns } from "./CommonScrollContainer.vue?vue&type=template&id=a6fbcb88&"
import script from "./CommonScrollContainer.vue?vue&type=script&lang=js&"
export * from "./CommonScrollContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports